module.exports = __webpack_public_path__ + "static/media/journalists.1d1eeda9.svg";